/* global Conf */
import React from 'react'
import { observable } from 'mobx'
import { observer, inject } from 'mobx-react'
import { Helmet } from 'react-helmet'
import { InputGroup, Button, ButtonGroup, DropdownButton, MenuItem } from 'react-bootstrap'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import BoolInput from 'bstrap-react-mobx-admin/input/bool'
import Datagrid from 'bstrap-react-mobx-admin/datagrid/datagrid'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import HelpOverlay from '../utils/helpOverlay'
import MultiSelect from 'react-select'
import Pagination from 'bstrap-react-mobx-admin/datagrid/pagination'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const ReportView = ({ store }) => {
  if (!store.loggedUser) {
    store.router.goTo(store.views.login, {}, store, {})
    return <h1>{store.__('insufficient rights')}</h1>
  }

  if (!store.router.queryParams || !store.router.queryParams._perPage) {
    store.router.queryParams = store.router.queryParams || {}
    if (localStorage.getItem('cargo_allPages') && store.router.queryParams && !store.router.queryParams._allPages) {
      store.showAllPages()
    } else if (!store.router.queryParams._allPages) {
      store.router.queryParams._page = 1
      store.router.queryParams._perPage = localStorage.getItem('cargo_perPage') || Conf.perPage || 50
    }
  }

  function _renderTD (i) {
    if (['slug', 'video_slug', 'video_id'].includes(i)) {
      const thisEntity = linkConst.LINK_FILMS
      return (attr, row) => {
        const item = store.options.has(thisEntity) && store.options.get(thisEntity).find((item) => item[i === 'video_id' ? 'id' : 'slug'] === row[i])
        return store.hasRight(thisEntity) && item && item.id
          ? <TextField attr={attr} val={row[attr]}
            Component={({ text }) => (<a href='javascript:void(0)'
              onClick={() => store.router.goTo(store.views.entity_detail, { entityname: thisEntity, id: item.id }, store, {})}>{text}</a>)} />
          : <TextField attr={attr} val={row[attr]} />
      }
    } else if (['contract_id', 'ppr_package_title'].includes(i)) {
      const thisEntity = i === 'contract_id' ? linkConst.LINK_CONTRACTS : linkConst.LINK_PPROLLS_SETUP
      return (attr, row) => {
        const item = store.options.has(thisEntity) && store.options.get(thisEntity).find((item) => item[i === 'contract_id' ? 'id' : 'name'] === row[i])
        return store.hasRight(thisEntity) && item && item.id
          ? <TextField attr={attr} val={row[attr]}
            Component={({ text }) => (<a href='javascript:void(0)'
              onClick={() => store.router.goTo(store.views.entity_detail, { entityname: thisEntity, id: item.id }, store, {})}>{text}</a>)} />
          : <TextField attr={attr} val={row[attr]} />
      }
    } else if (['flyprivate_platform_tier_id', 'flyprivate_platform_tiers_id'].includes(i)) {
      return (attr, row) => (<TextField attr={attr} val={row[attr]}
        Component={({ text }) => (<a href='javascript:void(0)' onClick={() =>
          store.router.goTo(store.views.entity_detail,
            { entityname: linkConst.LINK_PRICING, id: row[i] },
            store, {})}>{text}</a>)} />
      )
    } else if (['contract_item_id'].includes(i)) {
      return (attr, row) => {
        return (row.contract_id
          ? <TextField attr={attr} val={row[attr]}
            Component={({ text }) => (<a href='javascript:void(0)' onClick={() =>
              store.goTo('contractitem_detail', {
                entname: linkConst.LINK_CONTRACTS,
                eid: row.contract_id,
                id: row[i]
              })}>{text}</a>)} />
          : <TextField attr={attr} val={row[attr]} />
        )
      }
    } else if (i === 'from') {
      return (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.to} />)
    } else if (i === 'to') {
      return (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.from} />)
    }

    return (attr, row) => (<TextField attr={attr} val={row[attr]} />)
  }

  function _renderParameters () {
    const isEnt = {}
    linkConst.REPORTS_ADD_ENTITIES.map(i => { isEnt[i.value] = i.multiparam || i.param })

    const inputs = store && store.cv.parameters && store.cv.parameters
      .sort((a, b) => a.parameter_number && b.parameter_number && (a.parameter_number - b.parameter_number))
      .map((p, k) => {
        const idParam = `${p.id}_param`
        let input
        let inputValue
        let optionsList
        let returnParam

        switch (p.type) {
        case 'number':
          input = (
            <TextInput
              attr={idParam}
              className={'filter-input'}
              record={store.cv.parametersRecord}
              type='number'
              onChange={(attr, val) => {
                store.cv.parametersRecord.set(attr, val)
              }} />
          )
          break

        case 'date':
          input = (
            <DateInput
              attr={idParam}
              className={'filter-input'}
              hideControlLabel
              nullHour
              record={store.cv.parametersRecord}
              onChange={(attr, val) => {
                store.cv.parametersRecord.set(attr, val)
              }} />
          )
          break

        case 'select':
          input = (
            <SelectInput
              attr={idParam}
              className={'filter-input'}
              optionsattr={p.options_attr}
              optionsrecord={store.options}
              record={store.cv.parametersRecord}
              valueattr={isEnt[p.options_attr] ? 'id' : 'value'}
              labelattr={(val, idx) => val && (val.text || val.label ||
                (val.name && (val.name + ' | ' + val.id)) ||
                (val.title && (val.title + ' | ' + val.id)) ||
                (val.tier && (`${val.platform} - ${val.type_sale} - ${val.tier} | ${val.id}`))
              )}
              onChange={(attr, val) => {
                store.cv.parametersRecord.set(attr,
                  (val === undefined || val === null ? null : val.toString())
                )
              }} />
          )
          break

        case 'multiselect':
          returnParam = (i, j) => {
            return j instanceof Array
              ? j.map(jj => { return i[jj] }).join(' - ')
              : i[j]
          }
          inputValue = store.options.has(p.options_attr) &&
            store.cv.parametersRecord.has(idParam) && store.cv.parametersRecord.get(idParam) &&
            store.cv.parametersRecord.get(idParam).length > 0 &&
            store.options.get(p.options_attr)
              .filter(i => store.cv.parametersRecord.get(idParam)
                .split(',')
                .includes(isEnt[p.options_attr] ? i.id.toString() : i.value))
              .map(i => {
                return {
                  value: (isEnt[p.options_attr] ? i.id.toString() : i.value),
                  label: (isEnt[p.options_attr] ? returnParam(i, isEnt[p.options_attr]) + ' | ' + i.id : i.text)
                }
              })
          optionsList = store.options.has(p.options_attr) &&
            store.options.get(p.options_attr).map(i => {
              return {
                value: (isEnt[p.options_attr] ? i.id.toString() : i.value),
                label: (isEnt[p.options_attr] ? returnParam(i, isEnt[p.options_attr]) + ' | ' + i.id : i.text)
              }
            })
          input = (
            <MultiSelect
              className='react-select-container'
              classNamePrefix='react-select'
              defaultValue={inputValue}
              isMulti={true}
              options={optionsList}
              value={inputValue}
              onChange={val => {
                store.cv.parametersRecord.set(idParam, val && val.length > 0 ? val.map(i => i.value).join(',') : '')
              }} />
          )
          break

        default:
          input = (
            <TextInput
              attr={idParam}
              className={'filter-input'}
              record={store.cv.parametersRecord}
              onChange={(attr, val) => {
                store.cv.parametersRecord.set(attr, val)
              }} />
          )
          break
        }

        return (
          <InputGroup className={'filter-input-group'} key={k}>
            { p.parameter_title
              ? <span className={'text-primary filter-input-title'}>{p.parameter_title}:</span>
              : null }
            { input } &nbsp;
          </InputGroup>
        )
      })

    return (
      <div className={'pull-left clear-both'}>
        <InputGroup className={'report-parameter-apply-button'}>
          <Button className='btn btn-success' onClick={store.loadWithParams.bind(store)}>
            <i className='glyphicon glyphicon-filter' />&nbsp;
            {store.__('Apply filters')} <HelpOverlay store={store} path='report/apply_filters' />
          </Button>
        </InputGroup>
        <InputGroup className={'report-parameter-clean-button'}>
          <Button className='btn btn-default' onClick={store.cleanParameters.bind(store)}>
            <span>x</span> <HelpOverlay store={store} path='report/clean_filters' />
          </Button>
        </InputGroup>
        { inputs }
      </div>
    )
  }

  const totalItems = store.cv.items && store.cv.items.length
  const selection = store.cv.selection
  const fakeIDName = 'fake_id_const' // for reports without ID
  const _renderTable = items => {
    const page = store.router.queryParams && store.router.queryParams._page ? store.router.queryParams._page : 0
    const perPage = store.router.queryParams && store.router.queryParams._perPage ? store.router.queryParams._perPage : 0
    const offsetEnd = perPage > 1 ? (Math.min(page * perPage, totalItems) || 1) : totalItems
    const offsetBegin = Math.min((page - 1) * perPage, offsetEnd) || 0

    // add unique ID if missing in report
    if (items && items[0] && !items[0][fakeIDName]) {
      items = items.map((v, k) => Object.assign(v, { [fakeIDName]: k }))
      store.cv.fakeID = fakeIDName
    }

    // pagination
    const newItems = page && perPage ? items.slice(offsetBegin, offsetEnd) : items

    // selection
    const isSelected = idx => [...selection.get()].indexOf(idx) >= 0
    const onRowSelection = selectionIdx => {
      let selected = [...selection.get()]
      const isSelected = selected.indexOf(selectionIdx) >= 0
      if (selectionIdx.length < 1) {
        selected = []
      } else if (selectionIdx === 'all') {
        selected = items.map((i, idx) => idx)
      } else if (isSelected) {
        selected.splice(selected.indexOf(selectionIdx), 1)
      } else {
        selected.push(selectionIdx)
      }
      selection.set(selected)
    }

    // data-grid table
    const attrs = observable(Object.keys(items[0]))
    const fields = Object.keys(items[0]).map(_renderTD)
    return <Datagrid
      attrs={attrs}
      fakeID={store.cv.fakeID}
      fields={fields}
      isSelected={isSelected}
      onRowSelection={onRowSelection}
      onSort={store.sortReport.bind(store)}
      rowId={(row) => row.id}
      sortstate={store.cv.sortstate}
      state={store.cv}
      titles={attrs}
      newItems={newItems}
    />
  }

  // select
  const selected = selection && selection.get() && selection.get().length
  const title = store.cv.title + (store.cv.reportname
    ? (defaultConst.TITLE_DIVIDER + store.__(defaultConst.TITLE_DETAIL) + defaultConst.TITLE_DIVIDER + store.cv.reportname)
    : '')
  const listOfSelected = selection && [...selection.get()].map(i => {
    return store.router.queryParams._page
      ? i + (store.router.queryParams._page - 1) * store.router.queryParams._perPage
      : i
  })
  const listOfSelectedIDs = listOfSelected && store.cv && store.cv.items && store.cv.items
    .filter((v, k) => listOfSelected.includes(k))
    .map(v => v[fakeIDName])
  const listOfSelectedStr = listOfSelectedIDs && listOfSelectedIDs.join()

  // logo
  const logo = store.options.has('constantsList')
    ? store.options.get('constantsList').find(i => i.id === 'LOGO_FOR_REPORTS')
    : null
  const logoQuery = logo && store.cv.logo && encodeURI(`&logo=${logo.List_code}`)
  const logoCheckbox = logo && (<span className='reports-export-settings'>
    <span className='reports-export-separator'>|</span>
    <label htmlFor='logo' >{store.__('Add a logo to the PDF export:')} &nbsp;</label>
    <input onClick={_ => { store.cv.logo = !store.cv.logo }}
      id='logo' checked={store.cv.logo} type='checkbox' />
      &nbsp;
  </span>)

  // pagination
  store.totalItems = store.cv.items && store.cv.items.length
  const allPages = (store.router.queryParams && store.router.queryParams._allPages) || false
  const perPageTitle = allPages ? 'all' : (store.router.queryParams && store.router.queryParams._perPage) || ''
  const perPageRender = (position = 'bottom') => (
    <DropdownButton className='per-page-select' title={perPageTitle} dropup={position === 'bottom'} dropdown={position === 'top'}
      id='dropdown' onSelect={(num) => num === 'all' ? store.showAllPages() : store.setPerPage(num)}>
      {
        store.perPageOptions.map((i) => {
          return <MenuItem eventKey={i} key={i}>{i}</MenuItem>
        })
      }
      <MenuItem eventKey={'all'} key={'all'}>{store.__('All')}</MenuItem>
    </DropdownButton>
  )
  const pagination = (position = 'bottom', totalItems) => (
    <div className='card-block breadcrumb pagination-group'>
      <div className='pull-right'>
        <ButtonGroup>
          {!allPages && <Pagination.Pagination store={store} onChange={store.updatePage.bind(store)} />}
        </ButtonGroup>
        {perPageRender(position)}
      </div>
      <div className='pull-left'>
        <div><Pagination.PageInfo info={store} query={store.router.queryParams} totalItems={totalItems} /></div>
      </div>
    </div>
  )

  // final return
  return (
    <div className='card'>
      <Helmet title={store.__(linkConst.LINK_REPORT_VIEW_TITLE) + (store.cv.reportname
        ? (defaultConst.HTML_DIVIDER + store.cv.reportname + defaultConst.HTML_DIVIDER)
        : '')} />
      <div className='card-block'>
        <h4 className='card-title'>
          {title}<span className='header-id'>{store.cv.reportid ? '#' + store.cv.reportid : ''}</span>
        </h4>
        <p className='text-muted'>
          {Object.prototype.hasOwnProperty.call(store.cv, 'description') && store.cv.description &&
           store.cv.description !== 'N/A' && store.cv.description !== null
            ? store.cv.description
            : null}
          {Object.prototype.hasOwnProperty.call(store.cv, 'purpose') && store.cv.description &&
           store.cv.purpose !== 'N/A' && store.cv.purpose !== null
            ? (` (${store.__('Purpose')}: ` + store.cv.purpose + ')')
            : null}
        </p>
        {totalItems > 0 &&
          <div className='pull-left clear-both width-100pct reports-export-buttons'>
            <a className='btn btn-info'
              href={`${Conf.url}/reporting/download/csv/${store.cv.reportid}?csv=true&ids=${listOfSelectedStr}${
                store.cv.parametersForDownload ? '&parameters=' + JSON.stringify(store.cv.parametersForDownload) : ''
              }&token=${store.authToken}`} target='_blank' rel='noreferrer'>
              <em className='glyphicon glyphicon-download-alt' />&nbsp;
              {store.__('Download CSV')} <HelpOverlay store={store} path='report/download_csv_button' />
            </a>
            <a className='btn btn-info'
              href={`${Conf.url}/reporting/download/pdf/${store.cv.reportid}?pdf=true&format=list${logoQuery}&ids=${listOfSelectedStr}${
                store.cv.parametersForDownload ? '&parameters=' + JSON.stringify(store.cv.parametersForDownload) : ''
              }&token=${store.authToken}`} target='_blank' rel='noreferrer'>
              <em className='glyphicon glyphicon-download-alt' />&nbsp;
              {store.__('Download PDF list')} <HelpOverlay store={store} path='report/download_pdf_list_button' />
            </a>
            <a className='btn btn-info'
              href={`${Conf.url}/reporting/download/pdf/${store.cv.reportid}?pdf=truee&format=table${logoQuery}&ids=${listOfSelectedStr}${
                store.cv.parametersForDownload ? '&parameters=' + JSON.stringify(store.cv.parametersForDownload) : ''
              }&token=${store.authToken}`} target='_blank' rel='noreferrer'>
              <em className='glyphicon glyphicon-download-alt' />&nbsp;
              {store.__('Download PDF table')} <HelpOverlay store={store} path='report/download_pdf_table_button' />
            </a>
            <span>
              &nbsp;{store.__('Result:')} <span className='badge'>{totalItems}</span> {store.__('rows')}
            </span>
            {selected > 0 &&
              <span>
                <span className='reports-export-separator'>|</span>
                {store.__('Export selected:')} <span className='badge'>{selected}</span>&nbsp;
                {selected > 1 ? store.__('rows') : store.__('row')}
              </span>
            }
            {logoCheckbox}
          </div>
        }
        {store && store.cv.parameters && store.cv.parameters.length > 0 && _renderParameters()}
      </div>
      { totalItems > 0 && pagination('top', store.totalItems) }
      <div className='pull-left clear-both card-block'>
        {store.cv.loading && (<div><span className='glyphicon glyphicon-refresh glyphicon-refresh-animate' />{' '}{store.__('Loading...')}</div>)}
        {!store.cv.loading && (
          (store.cv.items.length > 0)
            ? _renderTable(store.cv.items)
            : store.cv.parametersForDownload &&
              Object.keys(store.cv.parametersForDownload).length > 0 &&
              (<div><br /><em>{store.__('There is nothing to show.')}</em></div>)
        )}
      </div>
      { totalItems > 0 && pagination('bottom', store.totalItems) }
    </div>
  )
}

export default inject('store')(observer(ReportView))
